/*
 * @version: 
 * @Author: Cuidezhen
 * @Date: 2023-04-19 13:56:59
 * @LastEditors: Cuidezhen
 * @LastEditTime: 2023-04-23 15:40:36
 * @company: 医视界
 * @FilePath: \village_platform\src\pages\columnManager\index.tsx
 * @Descripttion: 
 * @Edit Record: 
 */
import React, {useCallback, useState} from 'react'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons';
import FirstLevel from './components/FirstLevel';
import SecondLevel from './components/SecondLevel';
import { Tabs } from 'antd';

const { TabPane } = Tabs;

function Index() {

  const [key, setKey] = useState('1')
  const [fatherId, setFatherId] = useState('1')

  const click = useCallback((e: any)=>{
    setKey(e)  
  },[])

  const setId = useCallback((e: any)=>{
    setFatherId(e)  
  },[])


  return (
    <div style={{padding: '15px', background: '#fff'}}>
      <Tabs defaultActiveKey="1" activeKey={key} onChange={click}>
        <TabPane tab="一级栏目" key="1" ><FirstLevel setKey={click} setSecondId={setId}/></TabPane>

        <TabPane tab="二级栏目"  key="2" disabled><SecondLevel fatherId={fatherId}/></TabPane>
        
      </Tabs>
    </div>
  )
}

export default Index